import { observable } from './observable.js?vue3';

export const staticBreadcrumbs = observable('static_breadcrumbs', {
  items: [],
  hasInjectedBreadcrumbs: false,
});
